const walletHeaderHeight = 293;

export const useWalletScroll = () => {
	// Scroll to the top of the wallet view when changing tabs
	const scrollToTop = () =>
		new Promise(resolve => {
			setTimeout(() => {
				if (window.scrollY >= walletHeaderHeight) {
					window.scrollTo({ top: walletHeaderHeight });
				}
				resolve(true);
			});
		});

	return { scrollToTop };
};
